import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import './EventFormModal.css';

export default function AthleteFormModal({ onClose, onAthleteAdded, editData }) {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    birth_year: '',
    cnp: '',
    nr_legitimatie: '',
    email: '',
    phone: ''
  });
  const [isForeignCnp, setIsForeignCnp] = useState(false);
  const [foreignCountry, setForeignCountry] = useState('');
  const [countryError, setCountryError] = useState('');
  const VALID_COUNTRY_CODES = [
    'ROU', 'MDA', 'HUN', 'BGR', 'ITA', 'FRA', 'DEU', 'ESP', 'GBR'
  ];
  const isEdit = !!editData;
  const isAlreadyForeign = isEdit && editData?.is_foreign_cnp === 1;




useEffect(() => {
  if (editData) {
    console.log('EDIT DATA:', editData);

    setFormData({
      first_name: editData.first_name || '',
      last_name: editData.last_name || '',
      birth_year: editData.birth_year || '',
      cnp: editData.cnp || '',
      nr_legitimatie: editData.nr_legitimatie || '',
      email: editData.email || '',
      phone: editData.phone || ''
    });

    setIsForeignCnp(!!editData.foreign_country);
    setForeignCountry(editData.foreign_country || '');
  }
}, [editData]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    if (isForeignCnp) {
      if (!foreignCountry || !VALID_COUNTRY_CODES.includes(foreignCountry)) {
        alert('Codul de țară este invalid.');
        return;
      }
    }

    e.preventDefault();
    const token = localStorage.getItem('jwtToken');
    const url = editData
      ? 'https://www.fro.ro/api/athletes/edit.php'
      : 'https://www.fro.ro/api/athletes/create.php';

    const payload = {
      ...formData,
      is_foreign_cnp: isForeignCnp ? 1 : 0,
      nr_legitimatie: formData.nr_legitimatie?.trim() || null,
      foreign_country: foreignCountry,
      ...(editData ? { id: editData.id } : {})
    };


    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(payload)
      });

      const text = await res.text();
      try {
        const result = JSON.parse(text);
        if (result.success) {
          onAthleteAdded && onAthleteAdded();
          onClose();
        } else {
          alert('Eroare: ' + result.message);
        }
      } catch {
        alert('Răspuns invalid de la server:\n\n' + text);
      }
    } catch (err) {
      alert('Eroare rețea: ' + err.message);
    }
  };

  return (
    <div className="pe-backdrop" onClick={onClose}>
      <div
        className="pe-modal rf-modal"
        style={{ maxWidth: '520px' }}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        {/* HEADER */}
        <div className="pe-head">
          <h3 className="pe-title">{editData ? 'Editează sportiv' : 'Adaugă sportiv'}</h3>
          <button className="pe-close" aria-label="Închide" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        {/* BODY */}
        <form className="rf-body" onSubmit={handleSubmit} style={{ maxHeight: 'calc(92vh - 140px)', overflowY: 'auto' }}>
          {/* forțăm 1 coloană */}
          <div className="rf-grid" style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 14 }}>
            <div className="rf-field">
              <label htmlFor="nr_legitimatie">Nr. legitimație</label>
              <input
                id="nr_legitimatie"
                name="nr_legitimatie"
                type="text"
                value={formData.nr_legitimatie}
                onChange={handleInputChange}
                placeholder="ex: 12345"
              />
            </div>

            <div className="rf-field">
              <label htmlFor="first_name">Nume <span className="req">*</span></label>
              <input
                id="first_name"
                name="first_name"
                type="text"
                required
                autoComplete="given-name"
                value={formData.first_name}
                onChange={handleInputChange}
                autoFocus
              />
            </div>

            <div className="rf-field">
              <label htmlFor="last_name">Prenume <span className="req">*</span></label>
              <input
                id="last_name"
                name="last_name"
                type="text"
                required
                autoComplete="family-name"
                value={formData.last_name}
                onChange={handleInputChange}
              />
            </div>

            <div className="rf-field">
              <label htmlFor="birth_year">An naștere <span className="req">*</span></label>
              <input
                id="birth_year"
                name="birth_year"
                type="number"
                inputMode="numeric"
                min="1930"
                max={new Date().getFullYear() - 5}
                required
                value={formData.birth_year}
                onChange={handleInputChange}
              />
            </div>



            <div className="rf-field">
              <label htmlFor="cnp">
                CNP {!isForeignCnp && <span className="req">*</span>}
              </label>

              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <input
                  id="cnp"
                  name="cnp"
                  type="text"
                  inputMode="numeric"
                  maxLength={13}
                  placeholder={isForeignCnp ? 'ID / document străin' : 'CNP'}
                  required={!isForeignCnp}
                  value={formData.cnp}
                  onChange={handleInputChange}
                  style={{ flex: 1 }}
                />

                <label
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    whiteSpace: 'nowrap',
                    cursor: 'pointer'
                  }}
                >
                  <input
                    type="checkbox"
                    checked={isForeignCnp}
                    disabled={isAlreadyForeign}
                    onChange={(e) => setIsForeignCnp(e.target.checked)}
                  />
                  {isAlreadyForeign && (
                    <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                      Sportivul este marcat definitiv ca străin.
                    </div>
                  )}

                </label>
              </div>
            </div>


            {isForeignCnp && (
              <div className="rf-field">
                <label htmlFor="foreign_country">
                  Țara (cod ISO – 3 litere) <span className="req">*</span>
                </label>

                <input
                  id="foreign_country"
                  type="text"
                  value={foreignCountry}
                  onChange={(e) => {
                    const val = e.target.value.toUpperCase();
                    setForeignCountry(val);

                    if (val.length === 3 && !VALID_COUNTRY_CODES.includes(val)) {
                      setCountryError(`Codul „${val}” nu există`);
                    } else {
                      setCountryError('');
                    }
                  }}
                  maxLength={3}
                  placeholder="ex: MDA"
                  required
                />

                {countryError && (
                  <div style={{ color: 'red', fontSize: 12, marginTop: 4 }}>
                    {countryError}
                  </div>
                )}
              </div>
            )}

            <div className="rf-field">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                value={formData.email}
                onChange={handleInputChange}
              />
            </div>

            <div className="rf-field">
              <label htmlFor="phone">Telefon</label>
              <input
                id="phone"
                name="phone"
                type="text"
                autoComplete="tel"
                value={formData.phone}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="rf-actions">
            <button type="button" className="btn btn-ghost" onClick={onClose}>Anulează</button>
            <button type="submit" className="btn btn-primary">
              {editData ? 'Salvează' : 'Adaugă'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
